export default "__VITE_ASSET__Dw7eNt3a__"